import { CodeList } from '@common/classes/codelist';
import { environment } from '@environments/environment.base';
import { NumberFormatOptions } from '@progress/kendo-angular-intl';
import { PropertyFunction } from './util.interface';

export function resolveProperty<T>(property: T | PropertyFunction<T>): T {
    return typeof property === 'function' ? (property as PropertyFunction<T>)() : property;
}

/**
 * Utility function to assign a type to an object.
 * It's usefull in templates when Angular can't infer the type of an object.
 * @param obj object to convert to type T
 * @returns obj typed as T
 */
export function toType<T>(obj: any): T {
    return obj as T;
}

export const defaultSelectLabel = (item: CodeList): string =>
    `${item.customText || (item.localizedCode || item.code || item.id) + (item.name ? ` - ${item.name}` : '')}`;

export const currencies: { value: string; label: string }[] = [
    { value: '$', label: '$ - US Dollar' },
    { value: '€', label: '€ - Euro' },
    { value: '£', label: '£ - British Pound Sterling' },
    { value: '¥', label: '¥ - Japanese Yen / Chinese Yuan' },
    { value: '₹', label: '₹ - Indian Rupee' },
    { value: '₽', label: '₽ - Russian Ruble' },
    { value: '₩', label: '₩ - South Korean Won' },
    { value: '₪', label: '₪ - Israeli New Shekel' },
    { value: '₫', label: '₫ - Vietnamese Dong' },
    { value: '₴', label: '₴ - Ukrainian Hryvnia' },
    { value: '₺', label: '₺ - Turkish Lira' },
    { value: '₿', label: '₿ - Bitcoin' },
    { value: '฿', label: '฿ - Thai Baht' },
    { value: '៛', label: '៛ - Cambodian Riel' },
    { value: '₡', label: '₡ - Costa Rican Colón' },
    { value: '₮', label: '₮ - Mongolian Tögrög' },
    { value: '₱', label: '₱ - Philippine Peso' },
    { value: '₦', label: '₦ - Nigerian Naira' },
    { value: '₨', label: '₨ - Pakistani / Sri Lankan Rupee' },
    { value: '₸', label: '₸ - Kazakhstani Tenge' },
    { value: '₲', label: '₲ - Paraguayan Guarani' },
    { value: '₳', label: '₳ - Argentine Austral (historic but recognizable)' },
    { value: '₵', label: '₵ - Ghanaian Cedi' },
    { value: '₼', label: '₼ - Azerbaijani Manat' },
    { value: '₾', label: '₾ - Georgian Lari' }
];

export const currencyFormat = (currentCurrency?: string): NumberFormatOptions => {
    const currency = currentCurrency ?? 'EUR';
    return environment.settings.input.currencyFormat({ currency });
};

export const currencySymbol = (currencyCode: string): string => {
    if (currencyCode === 'USD') return '$';

    return environment.settings.input.currencySymbol;
};
